import React from 'react'

const features = [
  {
    icon: 'fa fa-shopping-bag',
    title: 'Shop Local Businesses',
    description:
      'Discover participating local businesses and shop for eligible products through the DLMP21 network.'
  },
  {
    icon: 'fa fa-users',
    title: 'Join the Customer Network',
    description:
      'Register with DLMP21 and become part of a connected customer network with your unique DLMP Code.'
  },
  {
    icon: 'fa fa-credit-card',
    title: 'Simple Purchase Process',
    description:
      'Make your eligible monthly purchase, show your DLMP Code to the participating franchisee and get your purchase recorded.'
  },
  {
    icon: 'fa fa-line-chart',
    title: 'Track Your Rewards',
    description:
      'Monitor your eligible purchases, network activity and rewards through your DLMP21 account.'
  },
  {
    icon: 'fa fa-sitemap',
    title: 'Up to 21 Network Levels',
    description:
      'DLMP21 provides a structured customer network with rewards calculated according to the applicable 21-level reward structure.'
  },
  {
    icon: 'fa fa-handshake-o',
    title: 'Connect Businesses & Customers',
    description:
      'Participating businesses can reach customers through the DLMP21 platform and become part of the local business network.'
  }
]

export default function Choose() {
  return (
    <section className="w3l-content-11-main">
      <div className="content-design-11">
        <div className="wrapper">

          <h3 className="title-main">Why Choose DLMP21?</h3>

          <p className="text-center mb-5">
            A simple platform connecting customers and participating local
            businesses through everyday purchases and a structured reward network.
          </p>

          <div className="content-sec-11 column content-text">

            {features.map((feature, index) => (
              <div className="columns" key={index}>
                <div className="icon-eff">
                  <span
                    className={feature.icon}
                    aria-hidden="true"
                  ></span>
                </div>

                <div className="right-side">
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}

          </div>

        </div>
      </div>
    </section>
  )
}